export default __webpack_public_path__ + "static/media/wooli.a4a21d9d.png";